import { useEffect } from 'react';
/** Registers native voice intents for this input and removes them on cleanup. */
export function useAskInputNativeVoiceEvents({ isTranscribing, isTranscriptionAvailable, onStartTranscription, onStopTranscription, onOpenVoiceToVoice, }) {
    useEffect(() => {
        const handleToggleDictation = () => {
            if (isTranscriptionAvailable) {
                if (isTranscribing) {
                    onStopTranscription?.();
                }
                else {
                    onStartTranscription?.();
                }
            }
        };
        const handleToggleVoiceToVoice = () => {
            onOpenVoiceToVoice();
        };
        document.addEventListener('toggleVoiceToVoice', handleToggleVoiceToVoice);
        document.addEventListener('toggleDictation', handleToggleDictation);
        return () => {
            document.removeEventListener('toggleDictation', handleToggleDictation);
            document.removeEventListener('toggleVoiceToVoice', handleToggleVoiceToVoice);
        };
    }, [
        isTranscribing,
        isTranscriptionAvailable,
        onStartTranscription,
        onStopTranscription,
        onOpenVoiceToVoice,
    ]);
}
//# sourceMappingURL=useAskInputNativeVoiceEvents.js.map